module.exports = __webpack_public_path__ + "static/media/logo.644bd03f.svg";